import { useRef, useState, useEffect } from 'react';
import { StyledVoiceSelect } from './VoiceSelect.styled';
import VoiceSelectOption from './VoiceSelectOption';
import { useAudio } from '../../providers/AudioContext';

const VoiceSelect = ({ options, disabled = false, selectedIndex = 0, onOptionSelected, modifyLabel = (label) => `${label} Voice` }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const selectedOption = options.length > selectedIndex ? options[selectedIndex] : null;
  const ref = useRef(null);
  const { playSFX } = useAudio();

  const hideDropwdown = () => {
    setShowDropdown(false);
  }

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      hideDropwdown();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [showDropdown]);

  return (
    <StyledVoiceSelect ref={ref} $selected={showDropdown} $disabled={disabled} $show={showDropdown}>
      <button className='voice-select-button' onClick={() => { playSFX('button'); setShowDropdown(!showDropdown); }} onMouseEnter={() => playSFX('hover')}>
        {selectedOption && (
          <div className='voice-select-button-content'>
            <div>{modifyLabel(selectedOption.name)}</div>
            <div className='voice-select-arrow' />
          </div>
        )}
      </button>
      <div className='voice-select-button-corner voice-select-button-corner-l' />
      <div className='voice-select-button-corner voice-select-button-corner-r' />
      {showDropdown && (
        <div className='voice-select-dropdown'>
          {options.map((o, ind) => (<VoiceSelectOption option={o} isSelected={selectedIndex === ind} onClick={() => {
            playSFX('menu_button');
            hideDropwdown();
            if (onOptionSelected) onOptionSelected(o);
          }}/>))}
        </div>
      )}
    </StyledVoiceSelect>
  )
};

export default VoiceSelect;

